/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_CopyrightInputs */

const en_landing_footer_copyright = /** @type {(inputs: Landing_Footer_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema`)
};

const de_landing_footer_copyright = /** @type {(inputs: Landing_Footer_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema`)
};

const fr_landing_footer_copyright = /** @type {(inputs: Landing_Footer_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema`)
};

const es_landing_footer_copyright = /** @type {(inputs: Landing_Footer_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema`)
};

const it_landing_footer_copyright = /** @type {(inputs: Landing_Footer_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema`)
};

const nl_landing_footer_copyright = /** @type {(inputs: Landing_Footer_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema`)
};

const pl_landing_footer_copyright = /** @type {(inputs: Landing_Footer_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema`)
};

const fi_landing_footer_copyright = /** @type {(inputs: Landing_Footer_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema`)
};

const da_landing_footer_copyright = /** @type {(inputs: Landing_Footer_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema`)
};

const sv_landing_footer_copyright = /** @type {(inputs: Landing_Footer_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema`)
};

/**
* | output |
* | --- |
* | "Alchema" |
*
* @param {Landing_Footer_CopyrightInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_footer_copyright = /** @type {((inputs?: Landing_Footer_CopyrightInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_CopyrightInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_footer_copyright(inputs)
	if (locale === "fr") return fr_landing_footer_copyright(inputs)
	if (locale === "es") return es_landing_footer_copyright(inputs)
	if (locale === "it") return it_landing_footer_copyright(inputs)
	if (locale === "nl") return nl_landing_footer_copyright(inputs)
	if (locale === "pl") return pl_landing_footer_copyright(inputs)
	if (locale === "fi") return fi_landing_footer_copyright(inputs)
	if (locale === "da") return da_landing_footer_copyright(inputs)
	if (locale === "sv") return sv_landing_footer_copyright(inputs)
	return en_landing_footer_copyright(inputs)
});